module.exports = __webpack_public_path__ + "static/media/round-button-secondary-dark.5d8c0951.svg";